module.exports = __webpack_public_path__ + "img/d4.18d5cc62.jpg";